var exports = {
  "k": "x93eb46d8--fbb84b--container",
};

module.exports = exports;
